import React, { useState, useRef, 
    // useEffect
 } from 'react';
// import { Table, TableBody, TableRow, TableCell } from '@mui/material'
;
import useTableScroll from '../../useTableScrollcesar';
import { Mensaje, MensajeSiNo } from '../../mensajes2';

import { Dimmer} from "../../spinner";

// import { verificarSeleccion, verificarSeleccionRet } from '../../../util/OperacionPago';
import axios from 'axios';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import { formatMoneda, validaSoloNumero } from '../../../util/varios';
import CatalogoComercio from '../../../catalogos/catalogoComercio';
// import CatalogoInmueble from '../../../catalogos/catalogoInmueble';
// import CatalogoVehiculo from '../../../catalogos/catalogoVehiculosAll';
// import CatalagoRentasInmo from '../../../catalogos/catalogoRentasInm2';
//import CatalogoAgenteTipo from '../../catalogos/catalogoAgenteTipo';
//import CatalogoAgenteTipo2 from '../../catalogos/catalogoAgenteTipo2';


export const FacturaTasasConexosPago = (props) => {

    moment.locale('es-us');

    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    // const anioActu = JSON.parse(localStorage.getItem('anioactu'));
    const idusuario = JSON.parse(localStorage.getItem('idusuario'));
    const [espiritu, setEspiritu] = useState(localStorage.getItem('espiritu'));

    // const txtIndice = useRef();
    const txtContribuyente = useRef();
    const chkSeleccionarDeuda = useRef([]);
    // const chkSeleccionarMulta = useRef([]);
    // const chkSeleccionarTasa = useRef([]);

    // const [idTipIngre, setIdTipIngre] = useState();
    // const [idTipImp, setIdTipImp] = useState();
    const [idTipIngreMulta, setIdTipIngreMulta] = useState();
    const [nomTablaContri, setNomTablaContri] = useState();
    // const [nomTabla, setNomTabla] = useState();
    // const [tipoImpu, setTipoImpu] = useState();
    // const [nomTablaDeuda, setNomTablaDeuda] = useState();
    const [idComercio, setIdComercio] = useState(0);
    // const [codImpu, setCodImpu] = useState(0);
    const [valorPetro, setValorPetro] = useState(0);
    const [valorUT, setValorUT] = useState(0.00);

    // const [disponiblesMulta, setDisponiblesMulta] = useState(0);
    // const [disponiblesTasa, setDisponiblesTasa] = useState(0);
    const [disponiblesDeuda, setDisponiblesDeuda] = useState(0);
    const [catalogoC, setCatalogoC] = useState(false);
    const [catalogoI, setCatalogoI] = useState(false);
    const [catalogoV, setCatalogoV] = useState(false);
    const [catalogoA, setCatalogoA] = useState(false);
    const [cuentasBanca, setCuentasBanca] = useState('0');
    // const [tabla, setTabla] = useState(null);
    const [tipoPago, setTipoPago] = useState("");
    const [catiDepo, setCantiDepo] = useState('0');
    const [efectivo1, setEfectivo1] = useState('0,00');
    const [efectivo2, setEfectivo2] = useState('0,00');
    const [fechaD1, setFechaD1] = useState("");
    const [fechaD2, setFechaD2] = useState("");
    const [numeroD1, setNumeroD1] = useState("");
    const [numeroD2, setNumeroD2] = useState("");
    const [montoT1, setMontoT1] = useState("0,00");
    const [montoT2, setMontoT2] = useState("0,00");
    const [montoT3, setMontoT3] = useState("0,00");
    const [fechaT1, setFechaT1] = useState("");
    const [fechaT2, setFechaT2] = useState("");
    const [fechaT3, setFechaT3] = useState("");
    const [numeroT1, setNumeroT1] = useState("");
    const [numeroT2, setNumeroT2] = useState("");
    const [numeroT3, setNumeroT3] = useState("");
    const [banCliT1, setBanCliT1] = useState("0");
    const [banCliT2, setBanCliT2] = useState("0");
    const [banCliT3, setBanCliT3] = useState("0");
    // const [idfactura, setIdFactura] = useState();
    // const [tipoTran, setTipoTran] = useState();
    // const [statusFac, setStatusFac] = useState();
    const [disabledAnio2, setDisabledAnio2] = useState(false);

    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mostrar2, setMostrar2] = useState(false);
    // const [records, setRecords] = useState([]);
    // const [visibleF, setVisibleF] = useState('hidden');
    const [activate, setActivate] = useState(false);
    // const [mensajeact, setMensajeact] = useState();
    const [btnDisabled, setBtnDisabled] = useState(true);
    // const [contribuyente, setContribuyente] = useState([]);
    // const [idcontribuyente, setIdcontribuyente] = useState(null);
    // const [vehiculo, setVehiculo] = useState('');

    const [multa, setMulta] = useState([]);
    const [tasa, setTasa] = useState([]);
    const [disabledDeuda, setDisabledDeuda] = useState(false);
    const [disabledMulta, setDisabledMulta] = useState(false);
    const [disabledTasa, setDisabledTasa] = useState(false);
    const [disabledAnio, setDisabledAnio] = useState(false);
    const [historico, setHistorico] = useState([]);
    // const [totDeuda, setTotDeuda] = useState('0,00');
    const [teclas, setTeclas] = useState();
    const [totalSelect, setTotalSelect] = useState({
        concepto: '',
        seleccionados: '',
        montoseleccionado: '',
        acrediSelect: '',
        montoFacturadoSelect: '',
        interesesSelect: '',
        multaSelect: '',
        recargoSelect: '',
        retenSelect: ''
    });

    const [values, setValues] = useState({
        concepto: '',
        seleccionados: 0,
        credito: '0,00',
        total: '0,00'
    });

    const [valuess, setValuess] = useState({
        idcontribuyente: '',
        nombre: '',
        rif: '',
        direccion: ''
    });

    //const [body, setBody] = useState(null);

    let token = localStorage.getItem('jwtToken');
    let op = require('../../../../src/modulos/datos');

    const headCells = [
        { label: '#', textAlign: 'center' },
        { label: 'Id Tasa', textAlign: 'center' },
        { label: 'Descripción', textAlign: 'left' },
        { label: 'Monto', textAlign: 'right' },
    ]

    const {
        TblContainer,
        TblHead
    } = useTableScroll(headCells);

    const onChange = (e) => {
        setValuess({ ...valuess, [e.target.name]: e.target.value });
        if (e.target.name === 'idcontribuyente') {
            validaSoloNumero(e);
        }
    }

    const SelectValorUT = (tasas) => {
        let valTasa = 0.00;
        // let unid = 1.00;
        let valorut = 0.00;
        let montoTasa = 0.00;
        let tas = [...tasas]
        let tipo = '';
        let m = parseInt(fechaSistema.substring(6, 8));
        let a = parseInt(fechaSistema.substring(0, 4));
        setActivate(true);
        var descripcion = "";
        for (let i = 0; i < tas.length; i++) {
            if (tas[i].factor === 0 || tas[i].factor === 5) {
                setValorUT(1.00);
                valorut = 1.00;
                valTasa = tasa[i].valor;
                montoTasa = (parseFloat(valTasa) * parseFloat(valorut)).toFixed(2);
                tas[i].monto = montoTasa;
            } else {
                //tipo = (tas[i].factor - 2).toString();
                m = parseInt(fechaSistema.substring(6, 8));
                a = parseInt(fechaSistema.substring(0, 4));

                var descripcion = "";


                let endpoint = `${op.conexion}/api/tasas/valorut?factorcalculo=${tas[i].factor}&anio=${a}&mes=${m}&espiritu=${espiritu}`;

                axios.get(endpoint, {
                    headers: {
                        'x-access-token': `${token}`
                    }
                }).then(function (response) {

                    if (response.status == 200) {
                        tipo = (tas[i].factor - 2).toString();
                        if (parseInt(espiritu) === 15) {
                            tipo = "0";
                        }
                        descripcion = tipo === "0" ? "Petros" : tipo === "1" ? "Sueldo Minimo" : tipo === "2" ? "UCAMP" : "";
                        if (response.data.length > 0) {
                            setValorUT(response.data[0].valor);
                            valTasa = tas[i].valor;
                            montoTasa = (parseFloat(valTasa) * parseFloat(response.data[0].valor)).toFixed(2);
                            tas[i].monto = montoTasa;

                        } else {
                            if (tas[i].factor > 1 && a > 2018) {
                                tas[i].monto = "0.00";
                                setMensaje({
                                    mostrar: true, titulo: 'Notificacion', texto: "El valor del " + descripcion + " para el año "
                                        + a + " del mes en curso no esta definido", icono: 'informacion'
                                });
                            }

                        }
                        //setActivate(false);

                    }

                }).catch(function (error) {

                    setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

                    setActivate(false);

                })
            }
        }

        setActivate(false);
        setTimeout(() => {
            setTasa(tas);
        }, 200);
    }

    const seleccionartipoIngreso = () => {

        setActivate(true);

        let campos = "*";
        let id = "0";
        let nomtab = "tasasweb";
        let nomid = "tramite";
        let condic = "conexos = true";
        let endpoint = `${op.conexion}/api/consulta/modelicondi?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}&condic=${condic}`
        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                console.log(response.data)
                var tas = [];
                //var his = [];
                for (let i = 0; i < response.data.length; i++) {

                    tas.push({

                        idtasasweb: response.data[i].idtasasweb,
                        descripcion: response.data[i].descripcion,
                        factor: response.data[i].factor,
                        idtipoingreso: response.data[i].idtipoingreso,
                        valor: response.data[i].valor,
                        monto: "0.00",
                        intereses: "0.00",
                        recargo: "0.00",
                        status: "Por Pagar",
                        //nummes: mm.toString().trim().padStart(2, "0"),

                    });

                }
                //setTasa(tas);
                SelectValorUT(tas);


            }
            //setActivate(false);

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })
    };

    const seleccionartipoIngresoMulta = () => {

        setActivate(true);

        let campos = '*';
        let nomtab = 'tipoimpuesto';
        let condi = 'tipofacturacion = 3';
        let orden = 'idtipoimpuesto';
        let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                console.log(response.data)

                for (let i = 0; i < response.data.length; i++) {
                    setIdTipIngreMulta(response.data[i].idtipoingreso);
                }
            }
            setActivate(false);

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })
    };

    const seleccionarValorPetro = () => {

        setActivate(true);

        let campos = '*';
        let nomtab = 'valorpetro';
        let condi = 'fechaaplic = (SELECT MAX(fechaaplic) AS fecha FROM valorpetro)';
        let orden = '1';
        let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                for (let i = 0; i < response.data.length; i++) {
                    setValorPetro(response.data[i].valor);
                }
            }
            setActivate(false);

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })
    };
    
    const procesarFactura = (body) => {

        let endpoint = `${op.conexion}/api/Caja_Ingreso/crearfactura`;
        setActivate(true);

        axios.post(endpoint, body, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {
            setActivate(false);
            if (response.status == 200) {
                valuess.idcontribuyente = "";
                valuess.rif = "";
                valuess.nombre = "";
                valuess.direccion = "";
                props.onHideAcepta();
                blanquear();
            }

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });
    }

    const chandleCheckDeuda = (item, index) => (e) => {
        //e.preventDefault();
        /*var deu = [...deuda];
        var montoseleccionado = 0.00;
        var montoFacturadoSelect = 0.00;
        var interesesSelect = 0.00;
        var multaSelect = 0.00;
        var recargoSelect = 0.00;
        var retenSelect = 0.00;
        var acrediSelect = 0.00;
        var per = props.tipo === 0 ? 'PAGO DE PUBLICIDAD ' : 'PAGO DE TASA DE LICORES DE ';
        var periodofac = '';
        var seleccionados = 0;
        var periodo = '';
        var continua = true;*/
        var montoseleccionado = totalSelect.montoseleccionado === '' ? "0.00" : totalSelect.montoseleccionado.replace(/\./g, '').replace(',', '.');
        var montoFacturadoSelect = totalSelect.montoFacturadoSelect === '' ? "0.00" : totalSelect.montoFacturadoSelect.replace(/\./g, '').replace(',', '.');
        var interesesSelect = totalSelect.interesesSelect === '' ? "0.00" : totalSelect.interesesSelect.replace(/\./g, '').replace(',', '.');
        var multaSelect = totalSelect.multaSelect === '' ? "0.00" : totalSelect.multaSelect.replace(/\./g, '').replace(',', '.');
        var recargoSelect = totalSelect.recargoSelect === '' ? "0.00" : totalSelect.recargoSelect.replace(/\./g, '').replace(',', '.');
        var retenSelect = totalSelect.retenSelect === '' ? "0.00" : totalSelect.retenSelect.replace(/\./g, '').replace(',', '.');
        var acrediSelect = totalSelect.acrediSelect === '' ? "0.00" : totalSelect.acrediSelect.replace(/\./g, '').replace(',', '.');
        var per = totalSelect.concepto === '' ? 'Periodo(s) de Pago: ' : totalSelect.concepto;
        var periodofac = '';
        var seleccionados = totalSelect.seleccionados === '' ? 0 : totalSelect.seleccionados;

        if (chkSeleccionarDeuda.current[index].checked === true) {

            //periodo = ' CORRESPONDIENTE AL PERIODO ' + item.mes + ' / ' + item.anio + ' ';
            if (parseFloat(item.monto) === 0.00) {
                chkSeleccionarDeuda.current[index].checked = false;
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No se puede facturar tasas con monto cero(0,00)...', icono: 'error' });
                return;
            }
            per = per + ' ' + item.descripcion.trim();// + periodo;
            seleccionados = seleccionados + 1;
            periodofac = periodofac + item.nummes + ' / ' + item.anio + ' ';
            montoseleccionado = parseFloat(montoseleccionado) + parseFloat(item.monto);
            montoseleccionado = Math.round(montoseleccionado * Math.pow(10, 2)) / Math.pow(10, 2);
            acrediSelect = parseFloat(acrediSelect) + parseFloat(item.credito);
            acrediSelect = Math.round(acrediSelect * Math.pow(10, 2)) / Math.pow(10, 2);
            montoFacturadoSelect = parseFloat(montoFacturadoSelect) + parseFloat(item.monto);
            montoFacturadoSelect = Math.round(montoFacturadoSelect * Math.pow(10, 2)) / Math.pow(10, 2);
            interesesSelect = parseFloat(interesesSelect) + parseFloat(item.intereses);
            interesesSelect = Math.round(interesesSelect * Math.pow(10, 2)) / Math.pow(10, 2);
            multaSelect = parseFloat(multaSelect) + parseFloat(item.multa);
            multaSelect = Math.round(multaSelect * Math.pow(10, 2)) / Math.pow(10, 2);
            recargoSelect = parseFloat(recargoSelect) + parseFloat(item.recargo);
            recargoSelect = Math.round(recargoSelect * Math.pow(10, 2)) / Math.pow(10, 2);
            retenSelect = parseFloat(retenSelect) + parseFloat(item.retenciones);
            retenSelect = Math.round(retenSelect * Math.pow(10, 2)) / Math.pow(10, 2);
        } else {

            per = per.replace(item.mes + ' / ' + item.anio + ' ', '');
            seleccionados = seleccionados - 1;
            periodofac = periodofac.replace(item.nummes + ' / ' + item.anio + ' ', '');
            montoseleccionado = parseFloat(montoseleccionado) - parseFloat(item.monto);
            montoseleccionado = Math.round(montoseleccionado * Math.pow(10, 2)) / Math.pow(10, 2);
            acrediSelect = parseFloat(acrediSelect) - parseFloat(item.credito);
            acrediSelect = Math.round(acrediSelect * Math.pow(10, 2)) / Math.pow(10, 2);
            montoFacturadoSelect = parseFloat(montoFacturadoSelect) - parseFloat(item.monto);
            montoFacturadoSelect = Math.round(montoFacturadoSelect * Math.pow(10, 2)) / Math.pow(10, 2);
            interesesSelect = parseFloat(interesesSelect) - parseFloat(item.intereses);
            interesesSelect = Math.round(interesesSelect * Math.pow(10, 2)) / Math.pow(10, 2);
            multaSelect = parseFloat(multaSelect) - parseFloat(item.multa);
            multaSelect = Math.round(multaSelect * Math.pow(10, 2)) / Math.pow(10, 2);
            recargoSelect = parseFloat(recargoSelect) - parseFloat(item.recargo);
            recargoSelect = Math.round(recargoSelect * Math.pow(10, 2)) / Math.pow(10, 2);
            retenSelect = parseFloat(retenSelect) - parseFloat(item.retenciones);
            retenSelect = Math.round(retenSelect * Math.pow(10, 2)) / Math.pow(10, 2);

        }


        if (item.status === 'Por Pagar') {
            item.status = 'Listo';
            setDisponiblesDeuda(disponiblesDeuda - 1);
        } else if (item.status === 'Listo') {
            item.status = 'Por Pagar';
            //setDisponiblesDeuda(disponiblesDeuda + 1);
        }

        setTotalSelect({
            concepto: per,
            seleccionados: seleccionados,
            montoseleccionado: formatMoneda(montoseleccionado.toString().replace('.', ','), ',', '.', 2),
            acrediSelect: formatMoneda(acrediSelect.toString().replace('.', ','), ',', '.', 2),
            montoFacturadoSelect: formatMoneda(montoFacturadoSelect.toString().replace('.', ','), ',', '.', 2),
            interesesSelect: formatMoneda(interesesSelect.toString().replace('.', ','), ',', '.', 2),
            multaSelect: formatMoneda(multaSelect.toString().replace('.', ','), ',', '.', 2),
            recargoSelect: formatMoneda(recargoSelect.toString().replace('.', ','), ',', '.', 2),
            retenSelect: formatMoneda(retenSelect.toString().replace('.', ','), ',', '.', 2),

        })

        if (seleccionados > 0) {
            setBtnDisabled(false);
        } else {
            setBtnDisabled(true);
        }

    };

    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    }

    const blanquear = () => {

        /*chkSeleccionarMulta.current = [];
        chkSeleccionarTasa.current = [];
        chkSeleccionarDeuda.current = [];*/
        setMulta([]);
        setTasa([]);
        setHistorico([]);
        //setDisabledMulta(0);
        setDisponiblesDeuda(0);
        setMostrar2(false);
        setBtnDisabled(true);
        setDisabledMulta(false);
        setDisabledTasa(false);
        setDisabledDeuda(false);
        setDisabledAnio(false);
        setDisabledAnio2(false);
        setCuentasBanca('0');
        setTipoPago('');
        setCantiDepo('0');
        setEfectivo1('0,00');
        setFechaD1('');
        setNumeroD1('');
        setEfectivo2('0,00');
        setFechaD2('');
        setNumeroD2('');
        setFechaT1('');
        setNumeroT1('');
        setBanCliT1('0');
        setMontoT1('0,00');
        setFechaT2('');
        setNumeroT2('');
        setBanCliT2('0');
        setMontoT2('0,00');
        setFechaT3('');
        setNumeroT3('');
        setBanCliT3('0');
        setMontoT3('0,00');
        setTotalSelect({
            concepto: '',
            seleccionados: '',
            montoseleccionado: '',
            acrediSelect: '',
            montoFacturadoSelect: '',
            interesesSelect: '',
            multaSelect: '',
            recargoSelect: '',
            retenSelect: ''
        });

        setValues({
            concepto: '',
            seleccionados: 0,
            credito: '0,00',
            total: '0,00'
        });
    }

    const handleCatalogo = () => {
        if (!catalogoC) {
            setCatalogoC(true);
        } else {
            setCatalogoC(false);
        }
    }

    const handleAceptaCatalogo = (id) => {
        setCatalogoC(false);
        datosContribuyente(id);
        //setValuess({ ...valuess, idcontribuyente: idcontri, nombre: nombage, rif: rif, direccion: direccion });

    }

    const datosContribuyente = (idcontri) => {
        let nomid = 'idcomercio';
        let nomtab = 'comercio';
        let tipo = 1;
        setIdComercio(0);
        setNomTablaContri('comercio');

        let campos = '*';
        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idcontri}&nomtab=${nomtab}&nomid=${nomid}`;

        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                if (response.data !== '') {
                    setIdComercio(response.data.idcomercio);
                    txtContribuyente.current.value = response.data.idcomercio;
                    valuess.rif = response.data.rif;
                    valuess.nombre = response.data.nombre;
                    valuess.direccion = response.data.direccion;

                } else {
                    //if (teclas === 13) {
                    //setActivate(false);
                    setTimeout(() => {
                        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Contribuyente no existe...', icono: 'error' });
                        txtContribuyente.current.value = "";
                        valuess.rif = "";
                        valuess.nombre = "";
                        valuess.direccion = "";
                        txtContribuyente.current.focus();
                    }, 100);
                    //}
                }
            }

            setActivate(false);

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })

    }

    const validarContribuyente = (event) => {
        event.preventDefault();
        valuess.idcontribuyente = event.target.value;
        valuess.nombre = '';
        valuess.rif = '';
        valuess.direccion = '';
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                setTeclas(event.which);
                datosContribuyente(event.target.value);
            } else {
                txtContribuyente.current.value = '';
            }
        }
    };

    const cancelar = (e) => {
        e.preventDefault();
        valuess.idcontribuyente = "";
        valuess.rif = "";
        valuess.nombre = "";
        valuess.direccion = "";
        props.onHideCancela();
        blanquear();
    }

    const onChangeValidar = (e) => {
        e.preventDefault();
        var factu = [];
        var factudet = [];
        if(valuess.nombre === ''){
            setMensaje({ mostrar: true, titulo: 'Notificacion', texto: "El Contribuyente no debe estar vacio.", icono: 'informacion'});
            txtContribuyente.current.focus();
            return;
        }
        for (let i = 0; i < tasa.length; i++) {
            if (tasa[i].status === 'Listo') {
                var factu = [];
                var factudet = [];

                factu.push({
                    //idcontribuyente: txtAgente.current.value,
                    totalinmpuesto: tasa[i].monto,
                    totalrecargo: 0.00,
                    totalinteres: 0.00,
                    idtipoingreso: tasa[i].idtipoingreso,
                    fechaemision: fechaSistema,
                    descripcion: tasa[i].descripcion,
                    tablacontribuyente: 'comercio',
                    //tabladeuda: 'deuda' || props.tipo,
                    status: 0,
                    nombrecontri: valuess.nombre,
                    direccioncontri: valuess.direccion,
                    cedrif: valuess.rif,
                    //totalmulta: totalSelect.multaSelect.replace(/\./g, '').replace(',', '.'),
                    totalmulta: 0.00,
                    //deducible: parseFloat(totalSelect.retenSelect.replace(/\./g, '').replace(',', '.')) + parseFloat(totalSelect.acrediSelect.replace(/\./g, '').replace(',', '.')),
                    deducible: 0.00,
                    facturador: idusuario,
                    //totalfactura: txtMonto.current.value.replace(/\./g, '').replace(',', '.')
                });

                factudet.push({
                    montoimpuesto: tasa[i].monto,
                    montorecargo: 0.00,
                    montointeres: 0.00,
                    periodo: fechaSistema.substring(6, 8) + '/' + fechaSistema.substring(0, 4),
                    //montomulta: deuda[i].multa,
                    //iddeuda: deuda[i].iddeu
                });

                let body = ({
                    idcontri: parseInt(txtContribuyente.current.value, 10),
                    factu: JSON.stringify(factu),
                    factudet: JSON.stringify(factudet),
                    nomtab: 'comercio',
                    tipoimpu: '',
                    idingremul: 0
                });
        
                procesarFactura(body);
            }

        }




        
        /*setDesde(0);
        let msg = 'Esta Seguro de Procesar la Declaración?.';
        setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });*/

    };

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                /*let obj = JSON.parse(localStorage.getItem('post'));
                setFechaSistema(obj.fechasistema);
                setIdUsuario(obj.idusuario);
                setEspiritu(obj.espiritu);*/
                seleccionartipoIngreso();
                //seleccionartipoIngresoMulta();
                seleccionarValorPetro();
            }}

        >
            <Modal.Header className='azulGradiant'>
                <div className='fw-bold text-light'><h3 className='text'>{props.tipoImpuesto}</h3></div>
                <button className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: "#FFF", color: "" }}>
                <div className='titulos' style={{ height: "auto", minHeight: "auto", maxHeight: "90vh", overflow: "auto" }}>
                    <div className="container">
                        {/*<div className="input-group py-1 input-group-sm col-sm-6">
              <label className="input-group-text" id="inputGroup-sizing-sm">Municipio:</label>
              <select disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtMunicipio} className="form-control form-control-sm" id="inputStatus" name='municipio' onChange={onChange} value={values.municipio.trim()} style={styleInput}>
                <option value="">Seleccione</option>
                {municipios && municipios.map((item, index) => (
                  <option key={index} value={item.idmunicipio}> {item.nombre} </option>
                ))}
              </select>
                </div>*/}
                        <fieldset className="row border-azul rounded mx-auto">
                            <legend className="float-none m-0 w-auto" >Datos del Contribuyente </legend>
                            <div className='col-md-12 row mx-auto px-0'>


                                <div className="input-group input-group-sm col-md-2 mb-2">
                                    <label htmlFor="idcontribuyente" className="form-label input-group-text" id="validationTooltipAgente">Código:</label>
                                    <input type="text" name="idcontribuyente" autoComplete='off' ref={txtContribuyente} defaultValue={valuess.idcontribuyente} onKeyUp={validarContribuyente} aria-describedby="validationTooltipAgente" placeholder="Código" className="form-control border" onChange={onChange} />
                                    <button className='btn btn-info' onClick={handleCatalogo}><i className='fa fa-search'></i></button>
                                </div>


                                <div className="input-group input-group-sm col-md-7 px-0 mb-2">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Nombres:</label>
                                    <input type="text" disabled className="form-control bg-light" autoComplete='off' aria-label="Sizing example input" value={valuess.nombre} aria-describedby="inputGroup-sizing-sm" name='nombre' />
                                </div>


                                <div className="input-group input-group-sm col-md-3 mb-2">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Cédula/Rif:</label>
                                    <input type="text" disabled className="form-control bg-light" autoComplete='off' aria-label="Sizing example input" value={valuess.rif} aria-describedby="inputGroup-sizing-sm" name='rif' />
                                </div>


                            </div>

                            <div className="input-group input-group-sm mx-auto col-md-12">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Dirección:</label>
                                <textarea type="textarea" style={{height:70}} disabled className="form-control bg-light" autoComplete='off' aria-label="Sizing example input" value={valuess.direccion} aria-describedby="inputGroup-sizing-sm" name='direccion' />
                            </div>

                        </fieldset>
                        <div className='col-md-12 py-1'></div>
                        <fieldset className='border-azul rounded row m-0'>
                            <legend className="float-none m-0 w-auto">Datos de la Deuda</legend>
                            <div className="col-md-12 mx-auto">
                                <div id='declaraciones'>
                                    <TblContainer container={{ maxHeight: 180, width: '100%', overflow: 'auto' }}>
                                        <TblHead />
                                        <tbody>
                                            {tasa && tasa.map((deu, index) => (

                                                <tr key={index} >
                                                    {deu.status === 'Por Pagar'
                                                        ? <td className='p-0 text-center letra-tabla-td'><input type="checkbox" ref={el => chkSeleccionarDeuda.current[index] = el} defaultChecked={deu.status === 'Por Pagar' ? false : true} onClick={chandleCheckDeuda(deu, index)} name={"chk" + deu.mes + deu.anio} style={{ width: 20, height: 20 }} /></td>
                                                        : <td className='p-0 text-center letra-tabla-td'><input type="checkbox" ref={el => chkSeleccionarDeuda.current[index] = el} defaultChecked={true} name={"chk" + deu.mes + deu.anio} onClick={chandleCheckDeuda(deu, index)} style={{ width: 20, height: 20 }} /* disabled={( deu.status === 'Listo' && ((tabla && tabla.tabla==='1x500') || ((deuda.length - disponiblesDeuda) === index + 1))) ? false : true} */ /></td>
                                                    }
                                                    <td className='p-0 text-center letra-tabla-td'>{deu.idtasaweb}</td>
                                                    <td className='p-0 text-left letra-tabla-td'>{deu.descripcion.trim()}</td>
                                                    <td className='p-0 text-right letra-tabla-td'>{formatMoneda(deu.monto.replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                                </tr>

                                            ))}
                                        </tbody>
                                    </TblContainer>
                                    {/*<div className='row col-12 p-0 m-0 border-table' style={{ borderTopStyle: 'hidden' }}>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className='p-0 text-end'><p style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: 14, margin: 0 }}>Facturado: {totalSelect.montoFacturadoSelect}</p></td>
                                                    <td className='p-0 text-end'><p style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: 14, margin: 0 }}>Interespor Mora: {totalSelect.interesesSelect}</p></td>
                                                    <td className='p-0 text-end'><p style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: 14, margin: 0 }}>Recargo por Mora: {totalSelect.recargoSelect}</p></td>
                                                    <td className='p-0 text-end'><p style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: 14, margin: 0, paddingRight: 5 }}>Total: {totalSelect.montoseleccionado}</p></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>*/}
                                </div>

                                {/*<div className='row col-12 p-0 m-0 border-table' style={{ borderTopStyle: 'hidden' }}>
                                    <div className='col-md-12 justify-content-start px-0'>
                                        <div className="input-group col-md-12 justify-content-start m-0">
                                            <p style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: 14, margin: 0 }} className='my-auto'>Concepto:</p> &nbsp;  <p style={{ fontFamily: 'Arial, Helvetica, sans-serif', fontSize: 14, margin: 0 }} className='my-auto'>{totalSelect.concepto} </p>
                                        </div>
                                    </div>
                                </div>*/}
                            </div>
                        </fieldset>
                    </div>
                </div>
            </Modal.Body >
            <Modal.Footer>
                <button disabled={btnDisabled} onClick={onChangeValidar} className="btn btn-sm rounded-pill btn-success col-md-2"><i className="fas fa-check-circle">  Aceptar</i></button>
                <button onClick={cancelar} className="btn btn-danger btn-sm rounded-pill col-md-2"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
            
<Dimmer active={activate} inverted>
       
      </Dimmer>
            <Mensaje mensaje={mensaje}
                onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
            <CatalogoComercio titulo={titulo} mensaje={msg}
                show={catalogoC}
                onHideCancelaCatCom={handleCatalogo}
                onHideAceptaCatCom={handleAceptaCatalogo}
            />
        </Modal >
    );
}